<div class='space_container label_container tile_block tile_blocks_widgets page_block'>
  <div class='tigger_btn delete_btn' (click)="deleteBlankView($event, 'delete')" title='Remove'>
    <span class='glyphicon glyphicon-remove'></span>
  </div>
  <div class='label_bg space_label'>Add a widget <br/> into this space</div>
</div>
